import { Popover } from "@mui/material";
import React, { useState, useContext } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { ApplicationStatus, LoanRepayment } from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import { PostLoanRepaymentApproval, insertIntoMemberEnrollmentHistory } from "../../../Helpers/APIEndPoints/EndPoints";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";
import "./LoanRepaymentVerifyModal.css";
import { Modules } from "../../../Helpers/Enums/Modules";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { VerifyModalModules } from "../Enums/VerifyModalModules";
const useGapStyles = makeStyles({
  paper: {
    marginTop: "-1rem",
  },
});

const LoanRepaymentVerifyModal = ({ open, anchorEl, handleClose, LoanRepaymentId, module }) => {
  const [hideShowComment, setHideShowComment] = useState(true);
  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [sendBack, setSendBack] = useState(false);
  const [error, setError] = React.useState<any>({});
  const navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const classes = useGapStyles();

  const onChange = (event, value) => {
    if (event === "comment") {
      setComment(value);
    } else if (event === "approve") {
      setApprove(value);
      setReject(!value);
      setSendBack(!value);

      setHideShowComment(true);
      setComment("");
    } else if (event === "reject") {
      setReject(value);
      setApprove(!value);
      setSendBack(!value);

      setHideShowComment(false);
    } else if (event === "sendback") {
      setSendBack(value);
      setApprove(!value);
      setReject(!value);

      setHideShowComment(false);
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    showLoader();

    if (approve === false && reject === false && sendBack === false) {
      notify(1, "Select at least one checkbox.");

      errorObj = { approve: "Select at least one checkbox." };
    }

    if (approve === false) {
      if (!comment) {
        errorObj = {
          ...errorObj,
          [comment]: "This field is required",
        };
      }
    }

    setError(errorObj);

    if (Object.keys(errorObj).length === 0) {
      let statusId = 0;

      let requestParams = {
        LoanRepaymentId: LoanRepaymentId,
        StatusId: statusId,
        Remarks: comment,
        Approver: context?.Id,
        MemberId: context?.MemberId
      };

      const isRepayment = module === VerifyModalModules.RepaymentDetails;
      if (approve) {
        statusId = isRepayment ? LoanRepayment.LoanRepayment_MemberPaymentDetailsPending : LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestAccept;
      } else if (reject) {
        statusId = isRepayment ? LoanRepayment.LoanRepayment_InternalTeamRejectLoanRepayment : LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestReject;
      } else if (sendBack) {
        statusId = isRepayment
          ? LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment
          : LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack;
      }

      requestParams.StatusId = statusId;

      const res = await APICall(PostLoanRepaymentApproval, requestParams);

      if (res.Status === ApiStatus.OK) {
        if (res.Message === "Success") {
          let mesaage = "";

          if (approve === true) {
            mesaage = "approved";
          }

          if (reject === true) {
            mesaage = "rejected";
          }

          if (sendBack === true) {
            mesaage = "sent back";
          }

          notify(ToastType.Success, `Request ${mesaage} Successfully.`);
          handleClose();
          navigate("/LoanApprovalDashboard");
        }
      } else {
        notify(ToastType.Error, "Loan repayment approval request submittion failed. Please Contact Administrator");
      }
    }
    hideLoader();
  };

  return (
    <Popover
      id={"id"}
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        paper: classes.paper,
      }}
      className=""
    >
      <div className="p-3 verify-modal">
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox id="approve" title="Approve" onChange={onChange} checked={approve} />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox id="reject" title="Reject" onChange={onChange} checked={reject} />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox id="sendback" title="Send Back" onChange={onChange} checked={sendBack} style={{ whiteSpace: "nowrap" }} />
            </div>
          </div>
          <br />
          {!hideShowComment && (
            <div className="row pb-3">
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group">
                  <label>Comments</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={comment}
                    textArea={true}
                    rows={4}
                    onChange={(val: any) => {
                      let value = val.target.value;
                      onChange("comment", value);
                    }}
                  />
                </div>
                {error[comment] && <p style={{ color: "red" }}>{error[comment]}</p>}
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent icon={""} className="btn btn-cancel" style={{ marginLeft: 5 }} onClick={handleClose} value={"Cancel"} id={"cancelBtn"} />
          <ButtonComponent icon={""} value={"Submit"} style={{ marginLeft: "10px" }} id={"saveBtn"} onClick={() => onSubmit()} />
        </div>
      </div>
    </Popover>
  );
};

export default LoanRepaymentVerifyModal;
